import React from "react";
import Card from "./Card";
import { useSelector } from "react-redux";

export default function Cards() {
  const Blogs = useSelector((state) => state.blogs);
  const filters = useSelector((state) => state.filters);
  console.log(filters);
  return (
    <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
      {Blogs.filter((blog) => {
        if (filters.author > 0) {
          return filters.author === blog.author.id;
        }
        return true;
      })
        .filter((blog) => {
          if (filters.cetagory.length > 0) {
            return filters.cetagory === blog.cetagory;
          }
          return true;
        })
        .filter((blog) => {
          if (filters.input.length > 0) {
            return blog.title
              .toLowerCase()
              .includes(filters.input.toLowerCase());
          } else {
            return true;
          }
        })
        .map((blog) => (
          <Card blog={blog} key={blog.id} />
        ))}
    </div>
  );
}
